/**
 * Author: Nin
 * simulate withRouter of react-router
 * fix issue: when we use withRouter of react-router, it will inject all MobX stores, it will cause render the component many times
 */
import React from "react";
import PropTypes from "prop-types";


const withRouter = (Child) => {
   return class extends React.Component {
    static contextTypes = {
                router: PropTypes.object
            }
           constructor(props, context) {
                    super(props, context);
                     this.state = {
                    router: this.context.router
                    }                           
            }
     render() {
       //console.log(" this.state.router",  this.state.router)
       let route = {
         location: (this.state.router && this.state.router.route)? this.state.router.route.location: null,
         match : (this.state.router && this.state.router.route)? this.state.router.route.match : null,
         history : (this.state.router && this.state.router.history)? this.state.router.history: null
       }
       return <Child {...route} {...this.props} />;
     }
   }
 };
 export default withRouter;



// WEBPACK FOOTER //
// ./src/app/common/decorator/withRouter.js